import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
Date.prototype.format = Date.prototype.format || function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "D+": this.getDate(), //日 
        "d+": this.getDate(), //日 
        "H+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/i.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};
window._sui_webpack_remote_path = window._sui_webpack_remote_path || '';
const _get_sui_webpack_remote_time = new Date().getTime();

/**
 * 获取url参数
 * @param {*} param 
 * @param {*} search 
 * @returns 
 */
function parseUrlQueryValue(param, search){
    var regExp = new RegExp(param+"=([^&=]+)?", "i");
    var matches = decodeURIComponent(search || location.search).match(regExp);
    return matches && matches[1] ? matches[1] : undefined;
}
/**
 * 获取sui远程包的url版本信息
 * @param {*} search 
 * @param {*} paramName 
 * @returns 
 */
function parseUrlQueryVers(search, paramName){
    paramName = paramName || "suiVers";
    var vers = {};
    var matched = parseUrlQueryValue(paramName, search);
    if ( matched ) {
        var pkgs = matched.split(",");
        for (var index = 0; index < pkgs.length; index++) {
            var pkg = pkgs[index];
            var _at = pkg.lastIndexOf('@'); 
            var pkgName = pkg.substring(0, _at);
            var pkgVer = pkg.substring(_at+1);
            if ( pkgName && pkgVer ) {
                vers[pkgName] = pkgVer;
            }
        }
    }
    return vers;
}

/**
 * 获取远程入口
 */
window._get_sui_webpack_remote_url = window._get_sui_webpack_remote_url || function(name, _path, ver, fileName) {
    fileName = fileName || "remoteEntry.js?_tt=" + _get_sui_webpack_remote_time;
    var path =  ((window._sui_webpack_remote_urls || {})[name]) || "", host;
    var queryVers = parseUrlQueryVers();
    var suiVer = parseUrlQueryValue("suiVer");
    var suiHost = parseUrlQueryValue("suiHost");
    if ( typeof path === "object" && path ) {
        host = path.host || host;
        ver = path.ver || ver;
        fileName = path.fileName || fileName;
        name = path.name || name;
        path = path.path || "";
    }
    ver = queryVers[name] || suiVer || ver;
    var verPath = ver ? ("/" + ver) : "";
    if ( (!path || suiHost) && name ) {
        host = suiHost || host || window._sui_webpack_remote_path;
        path = host ? host.replace(/[\/]+$/i, "").replace(new RegExp("/" + name), "")  + '/' + name : _path || "/";
        return path ? (path.replace(/[\/]+$/i, "") + verPath + "/" + fileName) : "";
    } else if(typeof path ==="string") {
        path = path.replace("/:ver", verPath);
    }
    return path || "";
}